import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../components/reverse-search/Sidebar/Sidebar";
import { Box, Button, CircularProgress, Drawer, IconButton, Input, InputBase, Paper, Tooltip, Typography } from "@mui/material";
import ChatInput from "../../components/reverse-search/Content/ChatInput";
import ChatContent from "../../components/reverse-search/Content/ChatContent";
import AnswerMessage from "../../components/reverse-search/Content/AnswerMessage";
import { toast } from "react-toastify";
import { publish } from "../../event/event";
import {
  API_BASE_URL,
  ROLE_USER,
  ROLE_ASSISTANT,
  ROLE_KNOWLEDGE,
} from "../../utils/const";
import axios from "axios";
import { SysMessage } from "../../components/reverse-search/Content/SysMessage";
import SummarizedMsg from "../../components/reverse-search/Content/SummarizedMsg";
import SearchIcon from "@mui/icons-material/Search";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MenuIcon from '@mui/icons-material/Menu';
import { useSearchParams } from 'react-router-dom';
import trees from "../../tree.json";


const ReverseSearch = ({ container, setContainer, selectedPaths, setSelectedPaths,setSelectedText,hierarchy,setHierarchy,selectedIds,setSelectedIds }) => {
  const [chatContents, setChatContents] = useState([]);
  const containerRef = useRef(null);
  const textareaRef = useRef(null);
  const scrollRef = useRef(null);
  const [isThinking, setIsThinking] = useState(false);
  const [chatText, setChatText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [chatLists, setChatLists] = useState([]);
  const [currentKeywords, setCurrentKeywords] = useState("");
  const [queryText, setQueryText] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [searchResult, setSearchResult] = useState({});
  const [currentInput, setCurrentInput] = useState("");
  const [error, setError] = useState("");
  const [isWorking, setWorking] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const [selectedChat, setSelectedChat] = useState(null);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const [selectedReferences, setSelectedReferences] = useState({
    text_search_document: [],
    semantic_search_document: [],
    google_search_results: [],
    google_com_search_results: []
  });

  const updateQueryText = (keywordsArray) => {
    const query = keywordsArray.map(item => item.value).join(' ');
    setQueryText(query);
  };

  const handleChange = (e) => {
    setCurrentInput(e.target.value);
    setError("");
  };


  const newChatClicked = async () => {
    setChatContents([]);
    setSelectedReferences({
      text_search_document: [],
      semantic_search_document: [],
      google_com_search_results: [],
      google_search_results: []
    });

    await axios.post(`${API_BASE_URL}/reverse_search/create-new-chat`).then((response) => {
      console.log("New chat created");
    });
  };

useEffect(() => {
    console.log(selectedChat, "Selected Chat")
    // setSelectedChat(null)
    if (!searchParams.get('chatId')) {
      newChatClicked()
    }

    
    
  }, []);

  const getNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      } else if (node.children && node.children.length) {
        const foundChild = getNodeById(node.children, id);
        if (foundChild) {
          return foundChild;
        }
      }
    }
    return null;
  };

  const getLabelTitle = (parent, title) =>
    parent && parent.length > 0 ? `${parent} > ${title}` : title;
  
  const reindexTree = (nodes, parents = [], path = "") => {
    return nodes.map((node, index) => {
      const currentId =
        parents && parents.length
          ? `${parents[parents.length - 1]}.${index + 1}`
          : `${index + 1}`;
      const newNode = {
        ...node,
        id: currentId,
        parents: parents,
        path: getLabelTitle(path, node.title),
      };
      const childParent = [...parents, currentId];
  
      if (node.children && node.children.length > 0) {
        newNode.children = reindexTree(node.children, childParent, newNode.path);
      }
      return newNode;
    });
  };
    const treeItems = reindexTree(trees);
  

    useEffect(() => {
      if (!hierarchy) {
        const parents = ["1", "2", "15"];
        setSelectedIds([...parents]);
        const paths = parents.map((parent) => getNodeById(treeItems, parent).path);
        console.log(paths)
        setSelectedPaths([...paths]);
      }
      
    }, [hierarchy]);
  console.log(selectedReferences, "Reverences in Reverse Search");

  const tempFunction = () => {
    console.log("in temp function");
  };

  const getSummary = async (_url, title, source) => {
    setChatContents((prevComponents) => [
      ...prevComponents,
      <SysMessage
        key={`sysMessage1_${new Date().getTime()}`}
        initialStatus={true}
        chatMsg={"Summarizing '" + title + "' ..."}
      />,
    ]);
    const postData = { url: _url, title: title, dataSource: source == "weaviate" ? "ato" : source };
    await axios
      .post(`${API_BASE_URL}/reverse_search/get-summary`, postData)
      .then((response) => {
        const responseKey = `responseBlock_${new Date().getTime()}`;
        const answerKey = `answerMessage_${new Date().getTime()}`;

        setChatContents((prevComponents) => [
          ...prevComponents,
          <React.Fragment key={responseKey}>
            <SummarizedMsg
              key={answerKey}
              answerMsg={{
                msg: response.data.summarization,
              }}
            />
          </React.Fragment>,
        ]);
      })
      .catch((error) => toast.error("Error fetching data:" + error))
      .finally(() => {
        publish("endLoading");
        hideSysMsgPromise();
      });
  };

  useEffect(() => {
    axios.get(`${API_BASE_URL}/reverse_search/get-all-chats`).then((response) => {
      setChatLists(response.data.chats);
    });
  }, []);

  useEffect(() => {
    if (selectedChat || searchParams.get('chatId')) {
      loadChatContent(selectedChat || searchParams.get('chatId'));
    }
  }, [selectedChat]);

  const loadChatContent = async (chatId) => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${API_BASE_URL}/reverse_search/get-all-qa`, {
        chat_id: chatId
      });

      // Transform the API response to match AnswerMessage expectations
      const messages = response.data.qa || [];
      const chatContentComponents = messages.map((message) => (
        <React.Fragment key={`chatContent_${message.id}_${new Date().getTime()}`}>
          {message.question && (
            <div className="chat-content-user">{message.question}</div>
          )}
          {message.answer && (
            <AnswerMessage
              answerMsg={{
                id: message.id,
                prompt: message.answer,
                metainfo: {
                  google_com_search_results: message.selected_search_results?.google_com_search_results || [],
                  google_search_results: message.selected_search_results?.google_search_results || [],
                  semantic_search_document: message.selected_search_results?.semantic_search_document || [],
                  text_search_document: message.selected_search_results?.text_search_document || []
                }
              }}
              setChatText={setChatText}
              setSelectedText={setSelectedText}
              setSelectedReferences={setSelectedReferences}
              selectedReferences={selectedReferences}
              getSummary={getSummary}
            />
          )}
        </React.Fragment>
      ));

      setChatContents(chatContentComponents);

      // Add auto-scrolling after content is loaded
      setTimeout(() => {
        if (containerRef.current) {
          containerRef.current.scrollTo({
            top: containerRef.current.scrollHeight,
            behavior: 'smooth'
          });
        }
      }, 100); // Small delay to ensure content is rendered

    } catch (error) {
      toast.error("Error loading chat: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const setQuery = ($event) => {
    if (queryText != '') {
      setChatText(queryText);
      getResponseFromServer(queryText);
    }
  };

  const addKeyword = () => {
    if (!currentInput.trim()) {
      setError("Keyword cannot be empty");
      return;
    }

    setKeywords([...keywords, { type: 'keyword', value: currentInput.trim() }]);

    setCurrentInput("");

    updateQueryText([...keywords, { type: 'keyword', value: currentInput.trim() }]);
  };

  const clearQuery = () => {
    setKeywords([]);
    setCurrentInput("");
    setQueryText("");
    setError("");
  };

  const addOperator = (operator) => {
    if (keywords.length === 0) {
      setError("Cannot add operator without a keyword");
      return;
    }

    const lastItem = keywords[keywords.length - 1];
    if (lastItem.type === 'operator') {
      setError("Cannot add two operators consecutively");
      return;
    }

    setKeywords([...keywords, { type: 'operator', value: operator }]);

    updateQueryText([...keywords, { type: 'operator', value: operator }]);
  };

  const removeLastItem = () => {
    if (keywords.length > 0) {
      const updatedKeywords = keywords.slice(0, -1);
      setKeywords(updatedKeywords);
      updateQueryText(updatedKeywords);
    }
  };

  const hideSysMsgPromise = async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    publish("hideSysMsg");
  };

  const getResponseForRef = (text) => {
    const postData = {
      prompt: text ?? "tax",
      username: "user",
      selected_search_results: selectedReferences,
      model: "gpt-4o",
    };
    setIsLoading(true);
    axios
      .post(`${API_BASE_URL}/reverse_search/get-query-response`, postData)
      .then((response) => {
        const responseKey = `responseBlock_${new Date().getTime()}`;
        const answerKey = `answerMessage_${new Date().getTime()}`;
        console.log(response.data, "Response");

        setChatContents((prevComponents) => [
          ...prevComponents,
          <React.Fragment key={responseKey}>
            <AnswerMessage
              key={answerKey}
              answerMsg={{
                id: response?.data?.data?.id,
                prompt: text,
                metainfo: response.data.data ? response?.data?.data : response?.data?.message
              }}
              setSelectedText={setSelectedText}
              setChatText={setChatText}
              setSelectedReferences={setSelectedReferences}
              selectedReferences={selectedReferences}
            />
          </React.Fragment>,
        ]);
        setTimeout(() => {
          if (containerRef.current) {
            containerRef.current.scrollTo({
              top: containerRef.current.scrollHeight,
              behavior: 'smooth'
            });
          }
        }, 100);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error("Error fetching data:" + error);
      })
      .finally(() => {
        publish("endLoading");
        setIsThinking(false);
        setIsLoading(false);
        textareaRef.current.value = "";
      });
  };

  const getResponseFromServer = (text) => {
    setIsThinking(true);

    const postData = {
      prompt: queryText.replace(/\s*(&|\|\|)\s*/g, " "),
      keywordsadv: queryText,
      hierrachy: selectedPaths?.length == 0 ? ["ATO general website"] : selectedPaths,
    };

    axios
      .post(`${API_BASE_URL}/reverse_search/get-search-data`, postData)
      .then((response) => {
        const responseKey = `responseBlock_${new Date().getTime()}`;
        const answerKey = `answerMessage_${new Date().getTime()}`;
        console.log(response.data, "Response");

        setChatContents((prevComponents) => [
          ...prevComponents,
          <React.Fragment key={responseKey}>
            <AnswerMessage
              key={answerKey}
              answerMsg={{
                id: response.data.data.id,
                prompt: text,
                metainfo: response.data.data
              }}
              setChatText={setChatText}
              setSelectedReferences={setSelectedReferences}
              selectedReferences={selectedReferences}
              setSelectedText={setSelectedText}
              getSummary={getSummary}
            />
          </React.Fragment>,
        ]);

        setTimeout(() => {
          if (containerRef.current) {
            containerRef.current.scrollTo({
              top: containerRef.current.scrollHeight,
              behavior: 'smooth'
            });
          }
        }, 100);
      })
      .catch((error) => {
        toast.error("Error fetching data:" + error);
      })
      .finally(() => {
        publish("endLoading");
        setIsThinking(false);
      });
  };

  return (
    <>
      <div className="chat-container">
        <Sidebar
          container={container}
          setContainer={setContainer}
          chatLists={chatLists}
          newChatClicked={newChatClicked}
          selectedChat={selectedChat}
          onChatSelect={(chatId) => setSelectedChat(chatId)}
        />

        <div className="main-container reverse-container">
          <span
            style={{ textAlign: "center", width: "100%", marginTop: "35px" }}
          ></span>
          <div>
            <Button
              variant="contained"
              onClick={toggleDrawer}
              startIcon={<MenuIcon />}
              sx={{ mb: 2, mt: "66px", ml: "8px" }}
            >
              Open Query Builder
            </Button>

            <Drawer
              anchor="right"
              open={open}
              onClose={toggleDrawer}
            >
              <Box
                sx={{
                  width: 750,
                  p: 2,
                  height: '100%',
                  overflow: 'auto'
                }}
                role="presentation"
              >
                <Typography variant="h6" sx={{ mb: 3 }}>
                  Query Builder
                  <IconButton
                    onClick={toggleDrawer}
                    sx={{ float: 'right' }}
                    aria-label="close drawer"
                  >
                    &times;
                  </IconButton>
                </Typography>

                <Paper
                  component="form"
                  onSubmit={(e) => e.preventDefault()}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderRadius: 3,
                    width: "100%",
                    padding: "15px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <Box sx={{ width: '100%', mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 500, color: '#424242', mb: 1, display: 'flex', alignItems: 'center' }}>
                      Query Builder
                      <Tooltip
                        title={
                          <React.Fragment>
                            <p><strong>Keyword:</strong> Any search term you want to find (e.g., "tax return", "deduction")</p>
                            <p><strong>AND (&):</strong> Both terms must appear in results</p>
                            <p><strong>OR (||):</strong> Either term must appear in results</p>
                            <p><strong>Examples:</strong></p>
                            <p>• "personal tax" & "deduction" - Find documents containing both terms</p>
                            <p>• "tax ruling" || "tax determination" - Find documents with either term</p>
                            <p>• "small business" & "tax" || "gst" - Find documents about small business tax or small business GST</p>
                          </React.Fragment>
                        }
                        placement="top"
                        sx={{ maxWidth: 400 }}
                      >
                        <IconButton size="small" sx={{ ml: 1, color: '#2895eb' }}>
                          <HelpOutlineIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#757575', fontSize: '13px' }}>
                      Build complex searches by combining keywords with AND (&) and OR (||) operators
                    </Typography>
                  </Box>

                  {keywords.length > 0 && (
                    <Box sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      width: "100%",
                      padding: "8px 12px",
                      marginBottom: "12px",
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      minHeight: "46px",
                      backgroundColor: "#fafafa"
                    }}>
                      {keywords.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            margin: "3px",
                            padding: "4px 10px",
                            borderRadius: "16px",
                            backgroundColor: item.type === 'keyword' ? '#e3f2fd' : '#f5f5f5',
                            border: item.type === 'keyword' ? '1px solid #bbdefb' : '1px solid #e0e0e0',
                            display: "inline-block",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: item.type === 'keyword' ? '#0d47a1' : '#616161',
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                          }}
                        >
                          {item.value}
                        </Box>
                      ))}
                    </Box>
                  )}

                  {error && (
                    <Typography color="error" sx={{ width: "100%", fontSize: "13px", marginBottom: "8px", fontWeight: 500 }}>
                      {error}
                    </Typography>
                  )}

                  <Box sx={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    overflow: "hidden",
                    transition: "all 0.2s ease",
                    '&:hover': {
                      borderColor: "#2895eb"
                    },
                    '&:focus-within': {
                      borderColor: "#2895eb",
                      boxShadow: "0 0 0 2px rgba(40, 149, 235, 0.1)"
                    }
                  }}>
                    <IconButton
                      type="button"
                      sx={{
                        p: "12px",
                        color: "#2895eb"
                      }}
                      aria-label="search"
                      onClick={() => {
                        if (keywords.length === 0 && !currentInput.trim()) {
                          setError("Please add at least one keyword to search");
                          return;
                        }

                        if (currentInput.trim()) {
                          const updatedKeywords = [...keywords, { type: 'keyword', value: currentInput.trim() }];
                          setKeywords(updatedKeywords);
                          updateQueryText(updatedKeywords);
                          setCurrentInput("");
                        }

                        setSearchResult({});
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      sx={{
                        ml: 1,
                        flex: 1,
                        fontSize: "15px",
                        '& input': {
                          padding: "10px 0"
                        }
                      }}
                      placeholder="Enter keyword"
                      value={currentInput}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();

                          if (!currentInput.trim() && keywords.length === 0) {
                            setError("Please enter a keyword");
                            return;
                          }

                          if (currentInput.trim()) {
                            addKeyword();
                          }

                          if (keywords.length > 0) {
                            setSearchResult({});
                          }
                        }
                      }}
                    />
                    {isWorking ? (
                      <CircularProgress size={20} sx={{ mr: 2, color: "#2895eb" }} />
                    ) : (
                      <div></div>
                    )}
                  </Box>

                  <Box sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-start",
                    marginTop: "15px",
                    gap: "12px",
                    flexWrap: "wrap"
                  }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={addKeyword}
                    >
                      Add Keyword
                    </Button>
                    <Tooltip
                      title="AND operator - Use to find documents containing BOTH keywords"
                      placement="top"
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => addOperator("&")}
                      >
                        AND (&)
                      </Button>
                    </Tooltip>
                    <Tooltip
                      title="OR operator - Use to find documents containing EITHER keyword"
                      placement="top"
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => addOperator("||")}
                      >
                        OR (||)
                      </Button>
                    </Tooltip>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={removeLastItem}
                    >
                      Remove Last
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={clearQuery}
                    >
                      Clear All
                    </Button>
                  </Box>

                  <Box sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    marginTop: "20px"
                  }}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={isWorking || keywords.length === 0}
                      startIcon={isWorking ? <CircularProgress size={16} color="inherit" /> : <SearchIcon />}
                      onClick={() => {
                        if (keywords.length === 0 && !currentInput.trim()) {
                          setError("Please add at least one keyword to search");
                          return;
                        }

                        if (currentInput.trim()) {
                          const updatedKeywords = [...keywords, { type: 'keyword', value: currentInput.trim() }];
                          setKeywords(updatedKeywords);
                          updateQueryText(updatedKeywords);
                          setCurrentInput("");
                        }
                        setOpen(false);
                        setQuery();
                        setSearchResult({});
                      }}
                    >
                      {isWorking ? "Searching" : "Search"}
                    </Button>
                  </Box>
                </Paper>

                {Object.keys(searchResult).length > 0 && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="subtitle1">Search Results</Typography>
                    <Paper sx={{ p: 2, mt: 1 }}>
                      <Typography variant="body2">
                        {JSON.stringify(searchResult)}
                      </Typography>
                    </Paper>
                  </Box>
                )}
              </Box>
            </Drawer>
          </div>

          <ChatContent
            isThinking={isThinking}
            containerRef={containerRef}
            chatContents={chatContents}
          />
          <ChatInput 
            keywords={keywords} 
            getResponseForRef={getResponseForRef} 
            containerRef={containerRef} 
            textareaRef={textareaRef} 
            isThinking={isLoading}
            selectedChat={selectedChat} // Add this prop
          />
        </div>
      </div>
    </>
  );
};

export default ReverseSearch;
